import React from 'react';
import { Check } from 'lucide-react';

/**
 * 1. CONFIGURATION DATA
 * Add or remove compliance items here easily.
 */
const COMPLIANCE_LIST = [
    "Company Registration",
    "Bank Account Assistance",
    "GST Registration",
    "Trade License",
    "GST Return Filing",
    "TDS Return Filing",
    "HR & Payroll Processing",
    "Trademark Protection",
    "MCA Compliance"
];

const ComplianceSolution = () => {
    return (
        <section className="bg-white py-20 px-6">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20">

                {/* Left Side: Mockup Image */}
                <div className="w-full lg:w-1/2">
                    <div className="relative rounded-[2.5rem] overflow-hidden shadow-2xl shadow-blue-100">
                        <img
                            src="https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?auto=format&fit=crop&q=80&w=1200"
                            alt="Platform Dashboard on Laptop"
                            className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700"
                        />
                        {/* Optional Overlay to match the warm lighting in the screenshot */}
                        <div className="absolute inset-0 bg-orange-900/5 mix-blend-multiply pointer-events-none"></div>
                    </div>
                </div>

                {/* Right Side: Content */}
                <div className="w-full lg:w-1/2 space-y-8">
                    <div className="space-y-4">
                        <h2 className="text-4xl font-bold text-[#1A2B3C] leading-tight">
                            Complete compliance solution
                        </h2>
                        <p className="text-gray-500 text-lg leading-relaxed max-w-xl">
                            From company registration to GST filing, income tax returns to trademark protection -
                            we handle all your compliance needs in one place.
                        </p>
                    </div>

                    {/* Checklist Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8">
                        {COMPLIANCE_LIST.map((item, index) => (
                            <div key={index} className="flex items-center gap-3 group">
                                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-50 flex items-center justify-center group-hover:bg-green-100 transition-colors">
                                    <Check size={14} className="text-green-600 stroke-[3px]" />
                                </div>
                                <span className="text-gray-700 font-medium text-[15px] group-hover:text-green-700 transition-colors">
                                    {item}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ComplianceSolution;